import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOMAIN_CONFIG } from './domain-config.token';

/**
 * Adds the multi-tenant `referer-domain` header to every outbound HTTP
 * request, mirroring legacy `fb-shipper-frontend/src/app/services/api-interceptor.service.js`
 * (lines 24-28).
 *
 * Resolution order:
 *   1. Use `window.location.hostname` (path / protocol stripped).
 *   2. If host is `localhost` or `192.168.*`, fall back to
 *      `DOMAIN_CONFIG.localHostName` so local-dev requests still identify
 *      the correct tenant.
 *
 * The header is set unconditionally (including on `/oauth/token`) because the
 * backend uses it to resolve tenant before authenticating credentials.
 */
export const domainInterceptor: HttpInterceptorFn = (req, next) => {
  const { localHostName } = inject(DOMAIN_CONFIG);
  const refererDomain = resolveRefererDomain(localHostName);

  return next(
    req.clone({
      setHeaders: { 'referer-domain': refererDomain },
    }),
  );
};

function resolveRefererDomain(fallback: string): string {
  const host = (typeof window !== 'undefined' && window.location?.hostname) || '';
  const isLocalLike = host === 'localhost' || host.startsWith('192.168.') || host === '127.0.0.1';
  return isLocalLike ? fallback : host;
}
